module.exports = __webpack_public_path__ + "img/switzerland-external-causes-male.a0d27c2a.png";